import { render } from "./IconPlus.vue?vue&type=template&id=7d74b1cc"
const script = {}

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__